module.exports = __webpack_public_path__ + "img/img1.7ce5d057.jpg";